module.exports = __webpack_public_path__ + "static/img/banner.caa84c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/banner.png
// module id = QgU8
// module chunks = 44